<template>
  <div class="login-content">
    <section class="login">
      <img class="loginLogo" :src="images.logo" /><router-view></router-view>
      <img class="adBanner" :src="images.family" />
    </section>
    <footer>
      <small>Sitio web privado de clientes <img :src="images.logo" /></small>
    </footer>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss" scoped>
.login-content {
  padding: 0;
}
.login {
  padding: 3% 5%;
  min-height: 93vh;
  display: grid;
  justify-items: center;
  align-items: center;
  .loginLogo {
    width: 300px;
  }
  .form {
    label {
      text-align: left;
    }
  }
  .adBanner {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }
}
footer {
  background-color: #efefef;
  display: flex;
  height: 50px;
  justify-content: center;
  small {
    display: flex;
    align-items: center;
    img {
      height: 15px;
    }
  }
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  components: {},
  data() {
    return {
      images: {
        logo: process.env.BASE_URL + "./media/logo.png",
        family: process.env.BASE_URL + "media/family.jpg",
      },
    };
  },
  methods: {},
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-4.jpg";
    },
  },
};
</script>
